module.exports = __webpack_public_path__ + "static/img/banner.cff7a4b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/banner.jpeg
// module id = DtMx
// module chunks = 0